import { render, staticRenderFns } from "./ComponentCard.vue?vue&type=template&id=5ab7da0e&scoped=true&"
import script from "./ComponentCard.vue?vue&type=script&lang=js&"
export * from "./ComponentCard.vue?vue&type=script&lang=js&"
import style0 from "./ComponentCard.vue?vue&type=style&index=0&id=5ab7da0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7da0e",
  null
  
)

export default component.exports